import { SquiggleItem } from "../types/types";

export const isNewItemId = ((itemId: string) => itemId.startsWith('*'));

export interface ItemHierarchyNode {
  item?: SquiggleItem;
  children: ItemHierarchyNode[];
};

export const makeHierarchy = (items: SquiggleItem[]) => {
  const itemMap = new Map<string, ItemHierarchyNode>();
  for (const item of items) {
    itemMap.set(item.id, { item, children: [] });
  }
  const roots: ItemHierarchyNode[] = [];
  for (const item of items) {
    const node = itemMap.get(item.id)!;
    if (!item.parent) {
      roots.push(node);
    } else {
      const parentNode = itemMap.get(item.parent);
      if (parentNode) {
        parentNode.children.push(node);
      } else {
        let emptyRoot = roots.find(r => !r.item);
        if (!emptyRoot) {
          emptyRoot = { item: undefined, children: [] };
          roots.unshift(emptyRoot);
        }
        emptyRoot.children.push(node);
      }
    }
  }
  return roots;
}

export const mapHierarchy = <T>(nodes: ItemHierarchyNode[], callback: (item: SquiggleItem|undefined, level: number) => T) => {
  const results: T[] = [];
  const traverse = (nodes: ItemHierarchyNode[], level: number) => {
    for (const node of nodes) {
      results.push(callback(node.item, level));
      traverse(node.children, level + 1);
    }
  };
  traverse(nodes, 0);
  return results;
}

export const itemSortingFunction = (a: SquiggleItem, b: SquiggleItem) => {
  if (!!a.archived !== !!b.archived) {
    return a.archived ? 1 : -1;
  } else if (!!a.starred !== !!b.starred) {
    return a.starred ? -1 : 1;
  } else {
    return a.name.localeCompare(b.name);
  }
};

export const itemStateSortingFunction = (a: SquiggleItem, b: SquiggleItem) => {
  if (!!a.archived !== !!b.archived) {
    return a.archived ? 1 : -1;
  } else if (!!a.starred !== !!b.starred) {
    return a.starred ? -1 : 1;
  } else {
    return 0;
  }
};

export const itemStateReverseChronologicalSortingFunction = (a: SquiggleItem, b: SquiggleItem) => {
  if (!!a.archived !== !!b.archived) {
    return a.archived ? 1 : -1;
  } else if (!!a.starred !== !!b.starred) {
    return a.starred ? -1 : 1;
  } else {
    return b.sortTimestamp - a.sortTimestamp;
  }
};